module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "realBody"
  }, [_c('div', {
    staticClass: "title_section"
  }, [_c('h1', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_c('span', [_vm._v(_vm._s(_vm.time))])])]), _vm._v(" "), _c('div', {
    staticClass: "body_section",
    attrs: {
      "id": "body_section"
    }
  }, [_c('div', {
    staticClass: "body_content",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }), _vm._v(" "), (_vm.communityName) ? _c('p', {
    staticClass: "notice-community-name-flag"
  }, [_c('span'), _vm._v(_vm._s(_vm.communityName)), _c('span')]) : _vm._e()])]), _vm._v(" "), (_vm.isNeedRead) ? _c('div', {
    staticClass: "btn-height"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "noData"
  }, [_c('img', {
    staticStyle: {
      "width": "150px",
      "padding-top": "35%"
    },
    attrs: {
      "src": require("../assets/image/nothing.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "noText"
  }, [_vm._v("暂无内容")])]), _vm._v(" "), (_vm.isNeedRead) ? _c('div', {
    staticClass: "btn-wrapper"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.read
    }
  }, [_vm._v("\n      点击签收\n    ")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cfda824"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notice.vue
// module id = 228
// module chunks = 1